import React, { useCallback, useEffect } from 'react';
import { observer } from 'mobx-react';

import TulumRealityShowStore from '../../../store/TulumRealityShowStore';
import AnchorLiveFeed from '../../../components/anchorComponents/AnchorLiveFeed/AnchorLiveFeed';
import LiveStreams from './LiveStreams';
import '../../../css/LiveBannerAnchor.css';
import bcgImage from '../../../assets/nn-live-bkg.png';

const TulumRealityShow = ({
  anchor,
  user,
  guestUser,
  anchorId,
  openContextualOverlay,
  slug,
  history,
  isSpotlighing,
  spotlighedAnchorUsername,
  spotlighedAnchorNickname,
  isLivePage,
  fetchStreamDetails,
  onNetworkError,
  extractIdFromSlug,
  galleriesAndVideosCount,
}) => {
  const {
    selectedStream,
    streams,
    selectedStreamID,
    chatAccess,
    hasStreamError,
    shouldExcludeFeatured,
    isFollowingFeaturedStream,
  } = TulumRealityShowStore;
  const isWhitelisted = user?.features?.includes('ANCHOR_PORTAL');
  const isAnchor = user?.user?.account?.anchor;
  const anchorIsActive = anchor?.active;

  const { authenticated } = user;
  let existingSubscription;
  if (authenticated) {
    const account = user?.user?.account;
    const { anchorSubscriptions } = account || {};
    const checkId = extractIdFromSlug();
    existingSubscription = anchorSubscriptions?.find((sub) => sub.subCategory === checkId);
  }

  const isSubscribed = Boolean(existingSubscription);

  const onProbation = parseInt(anchorId, 10) === 120;
  const canSubscribeToAnchor = !isAnchor && !onProbation && !isSubscribed && isWhitelisted && anchorIsActive && galleriesAndVideosCount > 0;
  const hasStreams = streams?.length > 0;

  useEffect(() => {
    TulumRealityShowStore.getTulumStreams();

    return function () {
      TulumRealityShowStore.reset();
    }
  }, []);

  const onCameraSelect = useCallback((streamId, profileUrl) => {
    if (profileUrl) {
      window.open(profileUrl);
    } else {
      TulumRealityShowStore.selectStream(streamId);
    }
  }, []);

  const handleStreamError = useCallback(() => {
      TulumRealityShowStore.toggleStreamError(true);
  }, []);

  const handleAllowStreamChangeOnError = useCallback(() => {
    TulumRealityShowStore.toggleAllowStreamChange(true);
  }, []);

  const handleFollowTulumFeatured = useCallback(isChecked => {
    TulumRealityShowStore.toggleFollowFeaturedStream(isChecked);
  });

  return (
    <div
      className="masthead live-anchor-banner-container"
      style={{
        background: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${bcgImage}) center center / contain`,
        paddingBottom: '5px',
        marginBottom: '20px',
      }}
    >
      {chatAccess && hasStreams && (
        <AnchorLiveFeed
          anchor={anchor}
          anchorVideoUrl={selectedStream}
          onNetworkError={onNetworkError}
          chatService={chatAccess}
          chatServiceTempted={chatAccess}
          user={user}
          slug={slug}
          guestUser={guestUser}
          anchorId={anchorId}
          background={anchor.promopic}
          openContextualOverlay={openContextualOverlay}
          isAnchor={isAnchor}
          canSubscribeToAnchor={canSubscribeToAnchor}
          isAlreadySubscribedToAnchor={isSubscribed}
          history={history}
          isLivePage={isLivePage}
          isSpotlighing={isSpotlighing}
          spotlighedAnchorUsername={spotlighedAnchorUsername}
          spotlighedAnchorNickname={spotlighedAnchorNickname}
          fetchStreamDetails={fetchStreamDetails}
          isWhitelisted={isWhitelisted}
          toggleStreamLoading={isLoading => TulumRealityShowStore.toggleStreamLoading(isLoading)}
          shouldHideVolumeRange
          isTulumRealityShow
          onTulumStreamError={handleStreamError}
          onAllowStreamChangeOnError={handleAllowStreamChangeOnError}
          hasStreamError={hasStreamError}
        />
      )}
      {(isSubscribed || isAnchor) && chatAccess && hasStreams && (
        <LiveStreams
          onCameraSelect={onCameraSelect}
          streams={streams}
          selectedStreamID={selectedStreamID}
          onFollowTulumFeatured={handleFollowTulumFeatured}
          shouldExcludeFeatured={shouldExcludeFeatured}
          isFollowingFeaturedStream={isFollowingFeaturedStream}
        />
      )}
    </div>
  )
}

export default observer(TulumRealityShow);
